import { render, staticRenderFns } from "./builtNewTemplateDialog.vue?vue&type=template&id=e83db960&scoped=true"
import script from "./builtNewTemplateDialog.vue?vue&type=script&lang=js"
export * from "./builtNewTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./builtNewTemplateDialog.vue?vue&type=style&index=0&id=e83db960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83db960",
  null
  
)

export default component.exports